import { PlanId } from "@/types";
import clsx from "clsx";
import { FC, useState } from "react";

const barLabels = [
  { index: 0, marker: "✌️", planId: PlanId.Launch, height: "h-[60%]" },
  { index: 1, marker: "🪂", planId: PlanId.Growth, height: "h-[70%]" },
  { index: 2, marker: "🚀", planId: PlanId.Scale, height: "h-[80%]" },
];

type BarProps = {
  planId: PlanId;
  active: boolean;
  readOnly: boolean;
  onClick: () => void;
};

export const Bar: FC<BarProps> = ({
  planId,
  active,
  readOnly,
  onClick = () => null,
}) => {
  const [showPrev, setShowPrev] = useState(false);

  const { marker, height, index }: any = barLabels.find(
    ({ planId: _planId }) => _planId === planId
  );

  return (
    <div
      className="flex flex-col gap-8 items-center h-full justify-end w-24 relative cursor-pointer"
      onClick={() => {
        !readOnly && onClick();
      }}
      onMouseEnter={() => {
        !readOnly && setShowPrev(true);
      }}
      onMouseLeave={() => {
        !readOnly && setShowPrev(false);
      }}
    >
      <span
        className={
          "text-6xl animate-fadein " + (active || showPrev ? "block" : "hidden")
        }
      >
        {marker}
      </span>
      <div
        className={clsx(
          "bg-black w-20 py-2 text-center absolute right-8 top-1/2 z-10 animate-fadein",
          {
            block: active || showPrev,
            hidden: !active && !showPrev,
          }
        )}
      >
        <span className="text-white capitalize">{planId}</span>
      </div>
      <div className={`relative ${height} w-full`}>
        <img
          src={`/images/checkout/bar-${index}-inactive.svg`}
          className="h-full absolute left-0 w-full object-cover"
        />
        <img
          src={`/images/checkout/bar-${index}-active.svg`}
          className={clsx(
            "h-full absolute left-0 w-full object-cover bottom-0 animate-slideup",
            {
              block: active,
              hidden: !active,
            }
          )}
        />
      </div>
    </div>
  );
};
